import {post} from '../utils'

export default host => (mainPersonId, mergePersonId) =>
  post(`${host}/people/${mainPersonId}/merge/${mergePersonId}`)
    .then(response => response.json())
